<div class="d-flex justify-content-end row mt-2" *ngIf="!loading && (associatedTerms.length > 0 || availableTerms.length > 0)">
	<div class="d-flex align-items-center col-12 col-sm-auto justify-content-end">
		<button
			mat-flat-button
			color="primary"
			type="button"
			class="app-key-menu-btn mr-2 app-key__associate-legal"
			(click)="associateTerms()"
			[disabled]="availableTerms.length === 0"
			i18n
		>
			Associate
		</button>
	</div>
</div>

<div
	*ngIf="!loading && mergedTerms.length === 0 && availableTerms.length > 0"
	class="col-12 alert alert-info alert-panel-text text-center mt-4"
	i18n
>
	This app key is currently not associated with any legal documents.
	<button title="View legal" type="button" class="button-link" (click)="associateTerms()">
		Click to begin associating legals.
	</button>
</div>

<div
	*ngIf="!loading && mergedTerms.length === 0 && availableTerms.length === 0"
	class="col-12 alert alert-info alert-panel-text text-center mt-4"
	i18n
>
	No legals available to associate with the app key. Review and manage your legals in the company legals section.
</div>

<div class="table-responsive" [ngClass]="{ 'hide-element': loading || mergedTerms.length === 0 }">
	<table mat-table matSort [dataSource]="mergedTerms" class="w-100" multiTemplateDataRows aria-label="List of associated legal documents">
		<ng-container matColumnDef="displayName">
			<th class="no-wrap" scope="col" mat-header-cell *matHeaderCellDef mat-sort-header i18n>Name</th>
			<td mat-cell *matCellDef="let row" class="text-nowrap">
				<button i18n-title title="View legal" type="button" class="button-link" (click)="viewTerm(row)">
					{{ row.displayName }}
				</button>
			</td>
		</ng-container>


		<ng-container matColumnDef="alias">
			<th class="no-wrap" scope="col" mat-header-cell *matHeaderCellDef mat-sort-header i18n>Alias</th>
			<td mat-cell *matCellDef="let row" class="text-nowrap">
				<button
					*ngIf="row?.alias"
					title="Copy alias to clipboard."
					[appCopyToClipboard]="row.alias"
					[appCopyToClipboardIcon]="true"
					i18n-title
					type="button"
					class="button-link"
				>
					{{ row.alias }}
				</button>
				<span *ngIf="!row?.alias" i18n>N/A</span>
			</td>
		</ng-container>

		<ng-container matColumnDef="version">
			<th class="no-wrap" scope="col" mat-header-cell *matHeaderCellDef i18n>Version</th>
			<td mat-cell *matCellDef="let row" class="text-nowrap">
				{{ row.documents[row.activeVersion].displayVersion }}
			</td>
		</ng-container>

		<ng-container matColumnDef="action" [stickyEnd]="true">
			<th scope="col" mat-header-cell *matHeaderCellDef class="text-center"></th>
			<td mat-cell *matCellDef="let row; let i = dataIndex" class="actions text-center no-wrap">
				<button
					mat-icon-button
					[matMenuTriggerFor]="actionMenu"
					aria-label="Action menu button"
					title="Available actions"
					i18n-title
					(menuClosed)="openedMenu = null"
					(menuOpened)="openedMenu = i"
					class="app-key-legal-actions"
				>
					<mat-icon>more_vert</mat-icon>
				</button>

				<mat-menu #actionMenu="matMenu">
					<button mat-menu-item i18n title="View legal" i18n-title (click)="viewTerm(row)">View legal</button>
					<button
						mat-menu-item
						i18n
						title="Disassociate legal"
						i18n-title
						(click)="unassociateTerm(row)"
						class="app-key-legal-actions__unassociate"
					>
						Disassociate legal
					</button>
				</mat-menu>
			</td>
		</ng-container>

		<tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
		<tr
			mat-row
			*matRowDef="let row; columns: tableColumns; let i = dataIndex"
			[ngClass]="{ menuOpen: openedMenu === i }"
			id="{{ row.termsId }}"
		></tr>
	</table>
</div>
